import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * Wrap any admin page with this. It checks the actual Supabase auth
 * session (not just the URL) and redirects unauthenticated visitors
 * to /admin/login, preserving where they were headed.
 */
export default function ProtectedRoute({ children }) {
  const { session, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F7F3EA]">
        <p className="text-[#00384D] text-sm">Checking your session…</p>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  return children;
}
